import { render, staticRenderFns } from "./DeviceRequestDetail.vue?vue&type=template&id=f979350c&scoped=true&"
import script from "./DeviceRequestDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRequestDetail.vue?vue&type=style&index=0&id=f979350c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f979350c",
  null
  
)

export default component.exports